var parameterInsert={
    RUT:'',
    BusinessName:'',
    Adress:'',
    ContactName:'',
    ContactPhone:'',
    ContactEmail:'',
    ContactPosition:'',
    ActivityEnterprises:'',
    Active:'1',
    User:'',
    IP:'',
    NameFileImg:'',
    APP_ANDROID_BUILD:'',
    APP_ANDROID_ACTIVE:2,
    APP_IOS_BUILD:'',
    APP_IOS_ACTIVE:2
} 
var parameterUpdate={
    IdEnterprise:'',
    RUT:'',
    BusinessName:'',
    Adress:'',
    ContactName:'',
    ContactPhone:'',
    ContactEmail:'',
    ContactPosition:'',
    ActivityEnterprises:'',
    Active:'1',
    User:'',
    IP:'',
    NameFileImg:'',
    APP_ANDROID_BUILD:'',
    APP_ANDROID_ACTIVE:0,
    APP_IOS_BUILD:'',
    APP_IOS_ACTIVE:0
} 
var parameterView={ 
    RUT:'',
    BusinessName:'', 
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}